'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DRGSiteService = function () {
    function DRGSiteService($http, $rootScope) {
        _classCallCheck(this, DRGSiteService);

        if ($rootScope && $rootScope.globals) $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
        this.$http = $http;
    }

    _createClass(DRGSiteService, [{
        key: 'getSite',
        value: function getSite() {
            return this.$http.get('' + WEBSERVICEURL + '/dataagility/api/service.refcode/queryall?domain=SITE');
        }
    }, {
        key: 'putSite',
        value: function putSite(siteId, data) {
            return this.$http.put(WEBSERVICEURL + '/dataagility/api/service.refcode/' + siteId + '/', data);
        }
    }]);

    return DRGSiteService;
}();

var QueryTemplateFileService = function () {
    function QueryTemplateFileService($http) {
        _classCallCheck(this, QueryTemplateFileService);

        this.$http = $http;
    }

    _createClass(QueryTemplateFileService, [{
        key: 'getQueryTemplateFile',
        value: function getQueryTemplateFile(queryTemplateId) {
            return this.$http.get(WEBSERVICEURL + '/dataagility/api/service.querytemplatefile/' + queryTemplateId);
        }
    }]);

    return QueryTemplateFileService;
}();

var SiteController = function SiteController($http, $scope, $rootScope, BuildNumber, $sce, FunctionService) {
    _classCallCheck(this, SiteController);

    $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
    this.name = 'Site Settings';
    this.options = {
        removeChromeAutoComplete: true
    };
    this.dRGSiteService = new DRGSiteService($http, $scope);

    this.hl7NotLoading = true;
    this.form = "site";
    this.model = {};
    this.functionSettings = {};
    this.buildNumber = BuildNumber;

    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
        $scope.vm.functionSettings = response.functionSettings;
    });

    $scope.vm.dRGSiteService.getSite().then(function successCallback(response) {

        $scope.vm.model = response.data[0];
    }, function errorCallback(response) {
        if (response.status === 401) {
            window.location.replace(window.location.origin + '/login?logout=true');
        }
    });

    this.checkValid = function () {

        // dis/enable submit button

        if ($scope.vm.form.$pristine) {

            return true;
        } else {

            if (Object.keys($scope.vm.form.$error).length === 0 && $scope.vm.form.$error.constructor === Object) {

                return false;
            } else {

                return true;
            }
        }
    };

    function base64ToArrayBuffer(data) {

        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);

        for (var i = 0; i < binaryLen; i++) {

            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }

        return bytes;
    };

    this.viewTemplate = viewTemplate;

    // Display the template PDF in a new tab or download if docx
    function viewTemplate(queryTemplateId) {
        $scope.vm.hl7NotLoading = false;
        $scope.vm.templateDownloading = true;

        new QueryTemplateFileService($http).getQueryTemplateFile(queryTemplateId).then(function successCallback(response) {
            var data = response.data;
            var arrBuffer = base64ToArrayBuffer(data.queryTemplate);
            var typeString = '';

            switch (data.queryTemplateFormat) {
                case 'zip':
                    typeString = 'application/zip';
                    break;
                default:
                // TODO: handle type error
            }

            var file = new Blob([arrBuffer], { type: typeString });
            var fileURL = URL.createObjectURL(file);
            window.open($sce.trustAsResourceUrl(fileURL));
            $scope.vm.templateDownloading = false;

            $scope.vm.hl7NotLoading = true;
        }, function errorCallback(response) {
            $scope.vm.templateDownloading = false;
            $scope.vm.hl7NotLoading = true;
        });
    }

    this.putData = function () {

        var data = JSON.stringify($scope.vm.model);

        $scope.vm.dRGSiteService.putSite($scope.vm.model.refCodeId, data).then(function successCallback(response) {

            $scope.snackBar('Site updated');
        }, function errorCallback(response) {

            $scope.snackBar("Database error, error saving Site.");
            if (response.status === 401) {
                window.location.replace(window.location.origin + '/login?logout=true');
            }
        });
    };

    $scope.snackBar = function (message) {

        // upgrade MDI components
        window.componentHandler.upgradeAllRegistered();

        var snackbarContainer = document.querySelector('#site__notification');

        var data = {
            message: message,
            timeout: 2000,
            actionHandler: $scope.finaliseCheck,
            actionText: 'test'
        };

        snackbarContainer.MaterialSnackbar.showSnackbar(data);
    };

    this.fields = [{
        type: 'lx-input',
        key: 'code',
        templateOptions: {
            'label': 'URL',
            required: true
        }
    }];
};

exports.default = SiteController;


// WEBPACK FOOTER //
// ./client/app/common/admin/site/site.controller.js